/**
 * Primivite Photo component.
 */

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { getImageSources, getMaxThumb, getMinThumb } from '../../util/photo';
import { IMAGE_SIZE_CODE } from '../../constants/image-size-codes';

const propTypes = {
  thumbs: PropTypes.arrayOf(
    PropTypes.shape({
      width: PropTypes.number,
      height: PropTypes.number,
      url: PropTypes.string,
    }),
  ),
  className: PropTypes.string,
  imgClassName: PropTypes.string,
  // Prevents users from right clicking and save and
  // generally all interactions with this photo
  blockCapture: PropTypes.bool,
  lowestQuality: PropTypes.bool,
  maxQuality: PropTypes.bool,
  onImageLoaded: PropTypes.func,
  onImageError: PropTypes.func,
  maxThumbnailSize: PropTypes.oneOf(Object.values(IMAGE_SIZE_CODE)),
  minThumbnailSize: PropTypes.oneOf(Object.values(IMAGE_SIZE_CODE)),
};

const Photo = ({
  thumbs,
  className,
  imgClassName,
  blockCapture,
  lowestQuality,
  maxQuality,
  onImageLoaded,
  onImageError,
  maxThumbnailSize,
  minThumbnailSize,
  ...props
}) => {
  const { src, srcSet } = getImageSources(
    thumbs,
    maxThumbnailSize,
    minThumbnailSize,
  );
  let srcFinal = src;

  const classes = classNames({
    photo: true,
    'block-capture': blockCapture,
    [className]: className,
  });

  const imgClasses = classNames({
    'photo-img': true,
    [imgClassName]: imgClassName,
  });

  if (lowestQuality) {
    const minThumb = getMinThumb(thumbs);
    srcFinal = minThumb && minThumb.url;
  }

  if (maxQuality) {
    const maxThumb = getMaxThumb(thumbs);
    srcFinal = maxThumb && maxThumb.url;
  }

  return (
    <div className={classes}>
      <img
        onLoad={onImageLoaded}
        onError={onImageError}
        className={imgClasses}
        src={srcFinal}
        srcSet={!(lowestQuality || maxQuality) ? srcSet : undefined}
        alt=""
        {...props}
      />
    </div>
  );
};

Photo.propTypes = propTypes;

export default Photo;
